import React from "react";
import { MdOutlineSave  } from "react-icons/md";
import styles from "./styles.module.css";
import { ClipLoader } from "react-spinners";

const BotaoSalvar = ({label, loading}) => {
    return (
        <button 
            className={styles.botaoSalvar} 
            type="submit"
            disabled={loading} 
        >
            {loading ? 
            (<ClipLoader size={15} color="#FFFFFF" />):
            <><MdOutlineSave className="icon" />{label}</>
            }
            
        </button>
    );
}

export default BotaoSalvar;